<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <h3>Historia kuwertury: {{ couvertureDetails.name }}</h3>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Data</th>
            <th>Osoba</th>
            <th>Akcja</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in historicRows" :key="row.id">
            <td>{{ row.date | moment("DD-MM-YYYY HH:mm HH:mm") }}</td>
            <td>{{ row.userName }}</td>
            <td style="white-space: pre">{{ row.text }}</td>
          </tr>
        </tbody>
      </table>
      <b-button variant="outline-primary" @click="$router.back();">
        Powrót
      </b-button>
    </div>
  </div>
</template>

<script>
import Loading from "../Common/Loading";
import axios from "axios";
import urlConfig from "../../mixins/url";
import toastr from "../../mixins/toastr";

export default {
  components: { Loading },
  mixins: [urlConfig, toastr],
  name: "CouvertureHistory",
  computed: {},
  mounted() {
    this.getData();
  },
  data() {
    return {
      isLoaded: false,
      historicRows: [],
      couvertureDetails: {},
    };
  },
  methods: {
    getData() {
      var that = this;
      var couvertureHistoryUrl =
        this.url.serverUrl +
        this.url.Couverture.GetHistoryForCouverture +
        this.$route.params.couvertureId;

      var couvertureDetailsUrl =
        this.url.serverUrl +
        this.url.Couverture.GetCouvertureInformationsById +
        this.$route.params.couvertureId;

      axios
        .all([axios.get(couvertureHistoryUrl), axios.get(couvertureDetailsUrl)])
        .then(
          axios.spread((couvertureHistory, couvertureDetails) => {
            that.historicRows = couvertureHistory.data;
            that.couvertureDetails = couvertureDetails.data;
            that.isLoaded = true;
          })
        )
        .catch((err) => {
          console.log(err);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(err);
          that.isLoaded = false;
        });
    },
  },
};
</script>